import { put, takeLatest, select } from 'redux-saga/effects';
import { RETRY_FAILED_ACTION } from '../constants/error';
import { hideErrorPopupAction } from '../actions/error';
import { getErrorAction } from '../selectors/error';

function* retryAction() {
  const action = yield select(getErrorAction);
  yield put({
    type: action,
  });
  yield put(hideErrorPopupAction());
}

export default function* () {
  yield takeLatest(RETRY_FAILED_ACTION, retryAction);
}
